import { render, staticRenderFns } from "./add-point.vue?vue&type=template&id=249c4724&scoped=true"
import script from "./add-point.vue?vue&type=script&lang=js"
export * from "./add-point.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./add-point.vue?vue&type=style&index=1&id=249c4724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249c4724",
  null
  
)

export default component.exports